import styled from "styled-components";

export const Container = styled.button`
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    svg {
      stroke: ${({ theme }) => theme.prevColors.red};
    }
  }

  svg {
    stroke: ${({ theme, active }) =>
      active ? theme.prevColors.red : theme.prevColors.grey};
    fill: ${({ theme, active }) =>
      active ? theme.prevColors.red : theme.prevColors.white};
  }
`;
